import axios from "axios";
import React, { Component,useEffect } from "react";
import { connect } from "react-redux";
import {Link} from "react-router-dom";
import {set_datapage} from '../../redux/actions/DataPageAction'
import { baseUrl,localUrl } from "helpers/Url";
import Swal from "sweetalert2";
import qs from 'query-string'
import {PageLength} from "helpers/Datatables";
import $ from 'jquery'
import dt from 'datatables.net'
$.DataTable = dt


class Recursoscites extends Component {
    
    constructor (props) {
        super(props)
        this.props.set_datapage('Lista de especies')
        this.state = {
            lista: false,
            cites: false,
            iucn: false,
            paises: false,
            recursos: false,
            tiporecurso:false,
            search:{txt_ncc:"",sel_cites: "", sel_iucn: "",sel_recurso: "",sel_tiporecurso: "",sel_pais: ""} ,
            regpag:process.env.REG_PAG,
            isloadsearch: true,
            total:0
          };
       
    }
    componentDidMount() {
        var params=qs.parse(this.props.location.search)
        //var url=baseUrl(`cites/reportes/initlistaespecies?l=25&o=0`)
        var url=baseUrl(`cites/reportes/initlistaespecies?`)
        var search=this.state.search
        if((params["q1"])){
            search['txt_ncc']=params["q1"]
            url+="&q1="+params["q1"]

        }
        if((params["q2"])){
            search['sel_cites']=params["q2"]
            url+="&q2 n="+params["q2"]

        }
        if((params["q3"])){
            search['sel_iucn']=params["q3"]
            url+="&q3="+params["q3"]

        }
        if((params["q4"])){
            search['sel_recurso']=params["q4"]
            url+="&q4="+params["q4"]

        }
        if((params["q5"])){
            search['sel_pais']=params["q5"]
            url+="&q5="+params["q5"]

        }
        if((params["q6"])){
            search['sel_tiporecurso']=params["q6"]
            url+="&q6="+params["q6"]

        }
        this.setState({
            search: search            
        })
        axios.get(url).then(res => {
            this.initpage(res.data);
        })
    }
    initpage(result){
        var resultados = result;        
        console.info("%c--- get reporte ", "color:yellow;background:green");
        var search=this.state.search
        const itemCites= resultados.cites.map((item) => {
            var selected=false
            if(this.state.search['sel_cites']==item.var_txt_description || this.state.search['sel_cites']==item.var_txt_name){search["sel_cites"]=item.var_txt_name;selected=true}
            return (
                <option value={item.var_txt_name} selected={selected}>{item.var_txt_description}</option>
            );
        })
        const itemIucn= resultados.iucn.map((item) => {
            var selected=false
            if(this.state.search['sel_iucn']==item.var_txt_description|| this.state.search['sel_iucn']==item.var_txt_name){search["sel_iucn"]=item.var_txt_name;selected=true}
            return (
                <option value={item.var_txt_name} selected={selected}>{item.var_txt_description}</option>
            );
        })
        const itempais= resultados.pais.map((item) => {
            var selected=false
            if(this.state.search['sel_pais']==item.pai_txt_name || this.state.search['sel_pais']==item.pai_int_id){search["sel_pais"]=item.pai_int_id;selected=true}
            return (
                <option value={item.pai_int_id} selected={selected}>{item.pai_txt_name}</option>
            );
        })
        const itemrecurso= resultados.recurso.map((item) => {
            var selected=false
            if(this.state.search['sel_recurso']==item.rec_txt_name || this.state.search['sel_recurso']==item.rec_int_id){search["sel_recurso"]=item.rec_int_id;selected=true}
            return (
                <option value={item.rec_int_id} selected={selected} title={item.rec_txt_description}>{item.rec_txt_name}</option>
            );
        })
        const tiporecurso= resultados.tiporecurso.map((item) => {
            var selected=false
            if(this.state.search['sel_tiporecurso']==item.var_txt_key || this.state.search['sel_tiporecurso']==item.var_txt_name || this.state.search['sel_tiporecurso']==item.var_int_id){search["sel_tiporecurso"]=item.var_int_id;selected=true}
            return (
                <option value={item.var_int_id} selected={selected} title={item.var_txt_name}>{item.var_txt_name}</option>
            );
        })
        this.setState({
            iucn: itemIucn,
            cites: itemCites,
            paises: itempais,
            recursos: itemrecurso,
            tiporecurso:tiporecurso,
            search:search        
        })
        this.getSearch()
        this.initDatatable() 
        
    }

    initDatatable = () => {
        

        const OnClick_acciones = (evt) => {
             let {accion, id} = evt.currentTarget.dataset
            switch (accion) {
                case 'ver':
                this.props.history.push(localUrl("/reportes/permisos/" + id))
                break;
            }
        }

        const OnCall = () => {

            this.setState({                   
                isloadsearch: true
            })
            
        }
        const OnFinish = () => {

            this.setState({                   
                isloadsearch: false
            })
            
        }
                
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns p-4'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/reportes/listaespecies_datatable"),
              data: (d) => {
                
                d.filter = this.getFilter()
                return d
              },
              beforeSend: function () {
                OnCall(); // show wating animation
              },
              error: function (xhr, error, thrown) {
                OnFinish()
                //alert(xhr.status);
                //alert(thrown);
                Swal.fire({
                    title: thrown,
                    html: `
                     <p> Se encontró un error en el servidor, intente más tarde.</p>
                     <p>Mensaje: ${xhr.status} - ${error}</p>
                    `,
                    icon: 'error'
                }).then(sr => {
                    
                  })
                
              }
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
              { data: "pli_int_id" , render: (d, t, r)=>{
                return r.index
              }},
              { data: "pli_txt_scientificname" },
              { data: "pli_txt_cite", render: (d, t, r)=>{ return r.pli_txt_cite.replace(/{/g, " ").replace(/}/g, " ") }},      
              { data: "pli_txt_uicncountry" },      
              { data: "pli_txt_uicn" },    
              { data: "rec_txt_name" },      
              { data: "pai_txt_name" },             
              { data: "pli_txt_scientificname", render: (d, t, r) => {
                return `
                    <div class="buttons is-centered">
                       <a class="button is-small is-primary" target="_blank" href="/biodiversidad/reportes/especies/dashboard/${d}">
                        <span class="icon"><i class="mdi mdi-eye"></i>
                        </span>
                       </a>                       
                    </div> `
              } }
            ],
            drawCallback: (dcall) => {
                this.setState({                   
                    //total:dcall._iRecordsDisplay,
                    isloadsearch: false
                })

                $('#tblEspecies_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblEspecies_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblEspecies_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblEspecies_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblEspecies_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblEspecies')
        
        // setTimeout(() => {
            
        this.datatable = this.table.DataTable(this.configDT).on('click', '.btn-acciones', OnClick_acciones)

        // }, 20000)
    }

    cargarregistros(datos){
        const listaItems = datos.registros.map((item,index) => {
            return (             
               <tr key={"registro_" + item.pli_int_id}>
               <td className="is-checkbox-cell">
                   {index+1}                               
               </td>                               
               <td >{item.pli_txt_scientificname}</td>
               <td>{item.pli_txt_cite}</td>
               <td >{item.pli_txt_uicncountry}</td>
               <td >{item.pli_txt_uicn}</td>
               <td title={item.rec_txt_description}>
                {item.rec_txt_name}
               </td>
               <td>
                 {item.pai_txt_name}
               </td>
               <td className="is-actions-cell">
               <div className="buttons is-right">
               <Link className="button is-small is-primary"  to={localUrl("/reportes/fichaespecie/"+item.pli_int_id)}>
               <span className="icon"><i className="mdi mdi-eye"></i></span>
              </Link>
               </div>
               </td>
               </tr>
            );
          });
          this.setState({
            lista: listaItems,
            total:datos.total,
            isloadsearch: false
        })
    }

    buscar_simple = () => {
        this.getSearch();
        this.datatable.draw()
        var url=this.getParamsUrl("/reportes/listaespecies?");  
        this.props.history.push(localUrl(url))       
    }
    getSearch(){
        var url=this.getParamsUrl("cites/reportes/listaespecies?l=25&o=0&tq=1"); 
        url=baseUrl(url)
        
        axios.get(url).then(res => {
            this.cargarregistros(res.data.datos);
        })
           

    }
    getParamsUrl(url){
        if(this.state.search['txt_ncc']!=""){
            url+="&q1="+this.state.search['txt_ncc']

        }
        if(this.state.search['sel_cites']!=""){
            url+="&q2="+this.state.search['sel_cites']

        }
        if(this.state.search['sel_iucn']!=""){
            url+="&q3="+this.state.search['sel_iucn']

        }
        if(this.state.search['sel_recurso']!=""){           
            url+="&q4="+this.state.search['sel_recurso']

        }
        if(this.state.search['sel_pais']!=""){
            url+="&q5="+this.state.search['sel_pais']
        }
        if(this.state.search['sel_tiporecurso']!=""){
            url+="&q6="+this.state.search['sel_tiporecurso']
        }
        return url;

    }
    getFilter(){

        return  {
            q1: this.state.search['txt_ncc'],
            q2: this.state.search['sel_cites'],
            q3: this.state.search['sel_iucn'],
            q4: this.state.search['sel_recurso'],
            q5: this.state.search['sel_pais'],
            q6: this.state.search['sel_tiporecurso'],
            }
      
    }

    ir_detalle = (e) => {
        const { especie } = e.target.dataset;
        var url="/reportes/fichaespecie/"+especie
        this.props.history.push(localUrl(url)) 
        
    }

    gestionarCambio = (event) => {
        var search=this.state.search
        if (event.target.type === "radio") {
            search[event.target.name]=event.target.value;
        } else {
            search[event.target.id]=event.target.value;
        }
        this.setState({          
            search:search
        })
      };


    render() {
        return (
            <div>
                <section className="section is-main-section">
                <div class="card">
                    <header class="card-header">
                        <p class="card-header-title">
                        Filtro
                        </p>
                       
                    </header>
                    <div class="card-content">
                        <div className="field is-horizontal">
                        <div className="field-body">
                                <div className="field">
                                       <label className="label">Nombre cientifico o común</label>
                                       <div className="control">
                                           <input className="input is-expanded" id="txt_ncc" size="50" type="text" placeholder="Ingrese nombre cientifico o común"  onChange={this.gestionarCambio} value={this.state.search.txt_ncc}></input>
                                       </div>
                                   </div>
                                    <div className="field">
                                       <label className="label">Appendices CITES</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_cites"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.cites}                                                          
                                           </select>
                                           </div>
                                       </div>
                                   </div>
                                   <div className="field ">
                                       <label className="label">Indicador UICN</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_iucn"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.iucn}                                                           
                                           </select>
                                           </div>
                                       </div>
                                   </div>
                                </div>           
                        </div>
                    <div className="field is-horizontal">
                                                     
                               <div className="field-body">
                                    <div className="field ">
                                       <label className="label">Tipo Recurso</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_tiporecurso"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.tiporecurso}                                                           
                                           </select>
                                           </div>
                                       </div>
                                   </div> 
                                   
                                   <div className="field ">
                                       <label className="label">Recurso</label>
                                       <div className="control">
                                           <div className="select">
                                           <select id="sel_recurso"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.recursos}                                                           
                                           </select>
                                           </div>
                                       </div>
                                   </div> 
                                   <div className="field">
                                        <label className="label">País</label>   
                                       <div className="field is-grouped">
                                        <div className="control">
                                           <div className="select">
                                           <select id="sel_pais"  onChange={this.gestionarCambio}>
                                               <option value="">--Seleccione--</option>
                                               {this.state.paises}                                                           
                                           </select>
                                           </div>
                                       </div> 
                                       <p className="control">
                                           <button className={"button is-link "+(this.state.isloadsearch?"is-loading":"")} onClick={this.buscar_simple}>Buscar</button>
                                       </p>
                                       </div>
                                       
                                   </div>
                               </div>
                               </div>

                    </div>
                    
                </div>
                    <div className="card has-table">                  
                        <div className="notification is-card-toolbar">
                            <div className="level">
                            <div className="level-left">
                                <div className="level-item">
                                    <strong>Lista de resultados</strong> 
                                </div>
                               
                            </div>
                            <div className="level-right">
                                <div className="level-item">
                                    {this.state.total} registros                            
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="card-content">
                        <div className="b-table has-pagination">
                            <div className="table-wrapper has-mobile-cards">
                                <table id="tblEspecies" className="table is-fullwidth is-striped is-hoverable is-fullwidth">
                                <thead>
                                <tr>
                                    <th> #  </th>
                                    <th>Nombre cientifico</th>
                                    <th>Appendice CITEs</th>
                                    <th>UICN Pais</th>
                                    <th>UICN</th>
                                    <th>Recurso</th>
                                    <th>Pais</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                    {/* {this.state.lista}                           */}
                                </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}


export default connect(null, {set_datapage})(Recursoscites)